export default __webpack_public_path__ + "static/media/DailySnapshot.1bbe1c5b.png";